import { Resource } from '@/classes';
import { ContactWithCustomer } from '@/local-types';

export default function contacts() {
  return new Resource<ContactWithCustomer>('Contacts').getSubtitleUsing((v) => v.customer.name);
}
